// src/components/LoadingScreen.tsx
import React from "react";
import logo from "../assets/images/logo.png";

interface LoadingScreenProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Loading application...",
  fullScreen = true,
}) => {
  return (
    <div
      className={`${fullScreen ? "min-h-screen" : "min-h-[60vh]"} bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200 dark:from-gray-900 dark:via-gray-800 dark:to-gray-950 flex items-center justify-center`}
    >
      <div className="text-center">
        <div className="relative">
          <div className="absolute -inset-4 bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-3xl blur-xl opacity-70"></div>

          <div className="relative bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200/30 dark:border-gray-700/30 p-12">
            {/* Spinner + Logo wrapper */}
            <div className="relative w-16 h-16 mx-auto">
              {/* Spinner */}
              <div className="absolute inset-0 rounded-full border-4 border-primary/20 border-t-primary animate-spin"></div>

              {/* Centered Logo */}
              <img
                src={logo}
                alt="Logo"
                className="absolute inset-0 m-auto w-10 h-10 transition-transform hover:scale-110"
              />
            </div>

            <p className="mt-6 text-gray-600 dark:text-gray-400 font-medium">
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
